import { AddTask, History, PushPin, Edit, Download } from '@mui/icons-material';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import React, { useState, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderPriority, ProcessStep } from '../../common/enums/enums';
import UnpinIcon from '../Icons/UnpinIcon';
import { MoveToInProcess } from './icons/MoveToInProcess';
import { MoveToWholeSale } from './icons/MoveToWholeSale';

export default function WorkOrderMenu({
  anchorEl,
  handleCloseMenu,
  selectedOrder,
  pintoTop,
  newEstimate,
  activityLog,
  editRo,
  exportWO,
  enablePinToTop,
  isAddEstimateDisabled,
  enableEditRo,
  enableExportWO,
  moveToWholeSaleFn,
  moveToInProcessFn,
}) {
  const { t } = useTranslation('workOrdersTable');
  const [currentOrderStatus, setCurrentOrderStatus] = useState({});

  const handleClickMenu = fn => () => {
    fn && fn(selectedOrder);
    handleCloseMenu();
  };

  const handleMoveToInProcess = fn => () => {
    fn && fn(selectedOrder);
    handleCloseMenu();
  };

  const handleMoveToWholeSale = fn => () => {
    fn && fn(selectedOrder);
    handleCloseMenu();
  };

  const addEstimateDisabled = useMemo(() => {
    return isAddEstimateDisabled(selectedOrder);
  }, [isAddEstimateDisabled, selectedOrder]);

  const assignOrderStep = step => {
    let orderStatusSteps = {};
    if (step === ProcessStep.MECHANICAL) {
      orderStatusSteps = {
        enableMoveToMechanic: false,
        enableMoveToWholeSale: true,
        enableMoveToInProcess: true,
      };
    } else if (step === ProcessStep.WHOLE_SALE) {
      orderStatusSteps = {
        enableMoveToMechanic: false,
        enableMoveToWholeSale: false,
        enableMoveToInProcess: true,
      };
    } else if (
      step === ProcessStep.IN_PROCESS ||
      step === ProcessStep.ARRIVED ||
      step === ProcessStep.IN_TRANSIT
    ) {
      orderStatusSteps = {
        enableMoveToMechanic: false,
        enableMoveToWholeSale: true,
        enableMoveToInProcess: false,
      };
    } else if (step === ProcessStep.DONE) {
      orderStatusSteps = {
        enableMoveToMechanic: false,
        enableMoveToWholeSale: false,
        enableMoveToInProcess: false,
      };
    }
    setCurrentOrderStatus(orderStatus => ({
      ...orderStatus,
      [selectedOrder?.orderId]: {
        ...orderStatusSteps,
      },
    }));
  };

  useEffect(() => {
    if (anchorEl && !currentOrderStatus?.[selectedOrder?.orderId]) {
      const step = selectedOrder?.step;
      assignOrderStep(step);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anchorEl]);

  useEffect(() => {
    const step = selectedOrder?.step;
    assignOrderStep(step);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrder]);

  return (
    <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleCloseMenu}>
      {enablePinToTop &&
        ((selectedOrder?.priority !== OrderPriority.HIGHEST && (
          <MenuItem onClick={handleClickMenu(pintoTop)}>
            <ListItemIcon>
              <PushPin
                sx={{ marginRight: '8px', color: 'rgba(0, 0, 0, 0.6)' }}
              />
            </ListItemIcon>
            <ListItemText>{t('vehicleTable.kebab.menu1')}</ListItemText>
          </MenuItem>
        )) || (
          <MenuItem onClick={handleClickMenu(pintoTop)}>
            <ListItemIcon>
              <UnpinIcon
                sx={{ marginRight: '8px', color: 'rgba(0, 0, 0, 0.6)' }}
              />
            </ListItemIcon>
            <ListItemText>{t('vehicleTable.kebab.menu4')}</ListItemText>
          </MenuItem>
        ))}
      {!addEstimateDisabled && (
        <MenuItem onClick={handleClickMenu(newEstimate)}>
          <ListItemIcon>
            <AddTask sx={{ marginRight: '8px', color: 'rgba(0, 0, 0, 0.6)' }} />
          </ListItemIcon>
          <ListItemText>{t('vehicleTable.kebab.menu2')}</ListItemText>
        </MenuItem>
      )}
      <MenuItem onClick={handleClickMenu(activityLog)}>
        <ListItemIcon>
          <History sx={{ marginRight: '8px', color: 'rgba(0, 0, 0, 0.6)' }} />
        </ListItemIcon>
        <ListItemText>{t('vehicleTable.kebab.menu3')}</ListItemText>
      </MenuItem>
      {enableEditRo && (
        <MenuItem onClick={handleClickMenu(editRo)}>
          <ListItemIcon>
            <Edit sx={{ marginRight: '8px', color: 'rgba(0, 0, 0, 0.6)' }} />
          </ListItemIcon>
          <ListItemText>{t('vehicleTable.kebab.menu5')}</ListItemText>
        </MenuItem>
      )}
      {enableExportWO && (
        <MenuItem onClick={handleClickMenu(exportWO)}>
          <ListItemIcon>
            <Download
              sx={{ marginRight: '8px', color: 'rgba(0, 0, 0, 0.6)' }}
            />
          </ListItemIcon>
          <ListItemText>{t('vehicleTable.kebab.menu6')}</ListItemText>
        </MenuItem>
      )}
      {currentOrderStatus?.[selectedOrder?.orderId]?.enableMoveToWholeSale && (
        <MenuItem onClick={handleMoveToWholeSale(moveToWholeSaleFn)}>
          <ListItemIcon>
            <MoveToWholeSale
              color="#666"
              sx={{ marginRight: '8px', color: 'rgba(0, 0, 0, 0.6)' }}
            />
          </ListItemIcon>
          <ListItemText>{t('vehicleTable.kebab.menu8')}</ListItemText>
        </MenuItem>
      )}
      {currentOrderStatus?.[selectedOrder?.orderId]?.enableMoveToInProcess && (
        <MenuItem onClick={handleMoveToInProcess(moveToInProcessFn)}>
          <ListItemIcon>
            <MoveToInProcess
              color="#666"
              sx={{ marginRight: '8px', color: 'rgba(0, 0, 0, 0.6)' }}
            />
          </ListItemIcon>
          <ListItemText>{t('vehicleTable.kebab.menu9')}</ListItemText>
        </MenuItem>
      )}
    </Menu>
  );
}
